import { RoboflowClient } from "./roboflow-client";
/**
 * Swap the implementation here — UI code should never import a concrete client.
 * Future: return an OnnxRuntimeClient for on-device WASM inference.
 */
export function createInferenceClient() {
    return new RoboflowClient();
}
